export function isWhitespaceString(str) {
  return !str?.replace(/\s/g, '').length;
}
